import { Fragment, useEffect } from "react";
import PropTypes from "prop-types";

function Sidebar({ 
    places, 
    onSetModalVisible, 
    onScrollToPosition, 
    handleHotspotAssigning, 
    showSidebar, 
    setShowSidebar,
    isDesktop
}) {

    function handleOpen(event, num) {
        event.preventDefault();
        event.stopPropagation();

        setShowSidebar(false);
        onScrollToPosition(num);
        onSetModalVisible(num);
    }

    useEffect(() => {
        if (document?.body) document.body.style.overflow = showSidebar ? 'hidden' : "auto";
    }, [showSidebar])

    return (
        <aside className={`mw-map-aside ${!showSidebar ? "collapsedSidebar" : ""}`}>
            <button
                className="sideBarToggler"
                onClick={() => setShowSidebar(!showSidebar)}
                aria-label={`"Tap to ${showSidebar ? "close navbar or scroll down to" : "open navbar and"} access all ${Object.keys(places).length} places"`}
            >
                <p>{`${showSidebar ? "Hide" : "Show"} locations`}</p>
                <span aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
                        <polygon points="9.03,0 5,4.06 0.97,0 0,0.94 5,6 10,0.94 " />
                    </svg>
                </span>
            </button>

            <nav>
                <ol>
                    {Object.keys(places).map((place, i) => (
                        <Fragment key={i}>
                            {places[place].displayInMap ? (
                                <li
                                    data-order={place}
                                    style={{animationDelay: `${i * 10}ms`}}
                                    className="placeWithHotspot"
                                >
                                    <button
                                        className="mw-map-aside-button"
                                        onClick={event => handleOpen(event, place)}
                                        onKeyDown={event => event.keyCode === 13 ? handleOpen(event, place) : null}
                                        onMouseEnter={() => handleHotspotAssigning(place, "sidebar")}
                                        onMouseLeave={() => handleHotspotAssigning(null)}
                                        onFocus={() => handleHotspotAssigning(place, "sidebar")}
                                        aria-label={`${isDesktop ? "Click" : "Tap"} here to open ${places[place].name} modal`}
                                    >
                                        {places[place].name}
                                    </button>
                                </li>
                            ) : (
                                <li
                                    data-order={place}
                                    style={{animationDelay: `${i * 10}ms`}}
                                    className="placeWithoutHotspot"
                                >
                                    <button 
                                        onClick={() => onSetModalVisible(place)}
                                        aria-label={`${places[place].name}: No 3d exploration available`}
                                        onFocus={() => handleHotspotAssigning(null)}
                                    >
                                        {places[place].name}
                                    </button>
                                </li>
                            )}
                        </Fragment>
                    ))}
                </ol>
            </nav>
        </aside>
    );
}

Sidebar.propTypes = {
    places: PropTypes.object.isRequired,
    onSetModalVisible: PropTypes.func.isRequired,
    onScrollToPosition: PropTypes.func.isRequired,
    handleHotspotAssigning:  PropTypes.func.isRequired
};

export default Sidebar;
